import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { InputDialogModel } from './../input-dialog/input-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class InputDialogService {
    private readonly _inputDialog: BehaviorSubject<InputDialogModel>;

    constructor() {
        this._inputDialog = new BehaviorSubject<InputDialogModel>(null);
    }

    public showInputDialog(inputDialog: InputDialogModel) {
        this._inputDialog.next(inputDialog);
    }

    public get inputDialog(): Observable<InputDialogModel> {
        return this._inputDialog.asObservable();
    }
}
